export default __webpack_public_path__ + "static/media/island01.310cfe63.jpeg";